var render = function render(_c,_vm){return _c('a',_vm._g(_vm._b({ref:"pagetop",staticClass:"p-pagetop",class:_vm.data.staticClass,attrs:{"href":"#"}},'a',_vm.data.attrs,false),_vm.listeners),[_c('img',{attrs:{"src":require("@/assets/img/common/ico_pagetop.png"),"alt":_vm.parent.$t('ページトップへ'),"width":"10","height":"20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }